import { LitElement, css, html } from 'lit'
import { customElement } from 'lit/decorators.js'

/**
 * An element specifically for being more explicit and reusable than <div style="display: contents;">
 */
@customElement('ep-contents')
export class EPContents extends LitElement {

  render() {
    return html`
      <slot></slot>
    `
  }

  static styles = css`
    :host {
      display: contents;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-contents': EPContents
  }
}
